/* eslint-disable react/prop-types */
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "./iframe"
import { usePolicyAndFleet } from "../contexts"
import { LowConnectivityBanner } from "../ui/components/LowConnectivityBanner"

interface RebatesV2Props extends RouteComponentProps {
  policyId?: string
}

export const RebatesV2: React.FC<RebatesV2Props> = ({ policyId }) => {
  const { policy, connectivity } = usePolicyAndFleet()

  return (
    <>
      {!!(connectivity.data || policy.connectivityRatio) && <LowConnectivityBanner policy={policy} />}
      <DocumentTitleOverride>Flock Motor | Rebates</DocumentTitleOverride>
      <IFrame path={`policies/${policyId ?? policy.id}/rebates`} />
    </>
  )
}
